import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _round from "lodash/round";
import _floor from "lodash/floor";
import "core-js/modules/es.array.concat.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import styles from "./Fraction.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Fraction = function Fraction(_ref) {
  var children = _ref.children;
  var calculateFunc = function calculateFunc(decimal) {
    var fractional = {
      numerator: 0,
      denominator: 0
    };
    if (decimal >= 0.875) {
      fractional.numerator = 7;
      fractional.denominator = 8;
    } else if (decimal >= 0.75) {
      fractional.numerator = 3;
      fractional.denominator = 4;
    } else if (decimal >= 0.666) {
      fractional.numerator = 2;
      fractional.denominator = 3;
    } else if (decimal >= 0.625) {
      fractional.numerator = 5;
      fractional.denominator = 8;
    } else if (decimal >= 0.5) {
      fractional.numerator = 1;
      fractional.denominator = 2;
    } else if (decimal >= 0.375) {
      fractional.numerator = 3;
      fractional.denominator = 8;
    } else if (decimal >= 0.333) {
      fractional.numerator = 1;
      fractional.denominator = 3;
    } else if (decimal >= 0.25) {
      fractional.numerator = 1;
      fractional.denominator = 4;
    } else if (decimal >= 0.125) {
      fractional.numerator = 1;
      fractional.denominator = 8;
    } else if (decimal >= 0) {
      fractional.numerator = 0;
      fractional.denominator = 0;
    }
    return fractional;
  };
  var formatQuantity = function formatQuantity(quantity) {
    // Calculate whole and decimal parts of quantity.
    var whole = _floor(quantity);
    var decimal = _round(quantity - whole, 3);

    // If the decimal is invalid.
    if (decimal && (decimal <= 0 || decimal >= 1)) {
      return {
        numerator: 0,
        denominator: 0
      };
    }
    return _objectSpread({
      whole: whole
    }, calculateFunc(decimal));
  };
  var quantity = formatQuantity(typeof children === 'number' ? children : 0);
  var frac = "&frac".concat(quantity.numerator).concat(quantity.denominator, ";");
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(quantity.whole && quantity.whole > 0 || !quantity.numerator) && /*#__PURE__*/_jsx("span", {
      className: styles.whole,
      children: quantity.whole
    }), quantity.numerator > 0 && /*#__PURE__*/_jsx("span", {
      className: styles.fraction,
      dangerouslySetInnerHTML: {
        __html: frac
      }
    })]
  });
};